export const countRecordsForTab = (typeID, typeName, collection) => {
  if (!Array.isArray(collection)) return 0;
  const id = parseInt(typeID, 10);
  return collection.filter((row) => row[typeName] === id).length;
};

export const tabHasRecords = (typeID, typeName, tableData) => {
  if (!tableData) return false;
  const isRevenue = typeName === "revenue_type_id";
  const collection = isRevenue ? tableData.revenues : tableData.expenses;
  return countRecordsForTab(typeID, typeName, collection) > 0;
};
